import React, { useState } from "react";
import Header from "../Sections/Safety/Header/Header";
import Banner from "../Sections/Safety/Banner/Banner";
import Zowo from "../Sections/Safety/Safety/Zowo";
import Control from "../Sections/Safety/Control/Control";
import FreeApp from "../Sections/Download/FreeApp";
import Industry from "../Sections/Safety/Industries/Industry";
import Party from "../Sections/Safety/Parties/Party";
import Footer from "../Footer/Footer";

const Safety = () => {
  return (
    <>
      <Header></Header>
      <Banner></Banner>
      <Zowo></Zowo>
      <Control></Control>
      <Industry></Industry>
      <Party></Party>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Safety;
